import { FinMasonError } from "@fartherfinance/frontend/api/Investment/types";

const genFinMasonErrorMsg = (error: FinMasonError) => {
  const invalidPositions =
    error.invalidPositions !== undefined
      ? `Invalid positions: ${Object.keys(error.invalidPositions).join(",")}`
      : "";

  return `${error.message} ${invalidPositions}`;
};

export default genFinMasonErrorMsg;
